module.exports = __webpack_public_path__ + "img/header-purple.7acd02c0.jpg";